// extracted by mini-css-extract-plugin
export var desktop_img = "FullWidthImagePanel-module--desktop_img--3c7dd";
export var full_width_img = "FullWidthImagePanel-module--full_width_img--4e9c0";
export var mobile_img = "FullWidthImagePanel-module--mobile_img--de4d9";
export var panelwrap = "FullWidthImagePanel-module--panelwrap--59f82";